import React, { useState } from 'react';
import { useAppContext } from '../contexts/AppContext';
import { translations } from '../utils/translations';

const Navbar = () => {
  const { darkMode, setDarkMode, language, setLanguage } = useAppContext();
  const t = translations[language];
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <nav className={`navbar navbar-expand-lg ${darkMode ? 'navbar-dark bg-dark border-bottom border-secondary' : 'navbar-light bg-white border-bottom'} shadow-sm`}>
      <div className="container-fluid px-3">
        {/* Brand */}
        <button
          type="button"
          className="navbar-brand fw-bold d-flex align-items-center btn btn-link p-0 m-0"
          style={{ fontSize: '1.3rem', textDecoration: 'none' }}
          tabIndex={0}
          aria-label="FODMAP App Home"
        >
          <span className="d-none d-sm-inline">FODMAP App</span>
          <span className="d-inline d-sm-none">FODMAP</span>
        </button>
        
        {/* Mobile Burger Button */}
        <button 
          className={`navbar-toggler border-0 p-2 ${darkMode ? 'text-light' : 'text-dark'}`}
          type="button" 
          onClick={toggleCollapse}
          aria-controls="navbarNav" 
          aria-expanded={!isCollapsed} 
          aria-label="Toggle navigation"
          style={{ fontSize: '1.1rem' }}
        >
          <div className="position-relative">
            <div 
              className={`hamburger-line ${!isCollapsed ? 'rotate-45' : ''}`}
              style={{
                width: '22px',
                height: '2px',
                backgroundColor: darkMode ? '#fff' : '#333',
                transition: 'all 0.3s ease',
                transformOrigin: 'center',
                transform: !isCollapsed ? 'rotate(45deg) translateY(6px)' : 'none'
              }}
            ></div>
            <div 
              className="hamburger-line my-1"
              style={{
                width: '22px',
                height: '2px',
                backgroundColor: darkMode ? '#fff' : '#333',
                transition: 'all 0.3s ease',
                opacity: !isCollapsed ? 0 : 1
              }}
            ></div>
            <div 
              className={`hamburger-line ${!isCollapsed ? '-rotate-45' : ''}`}
              style={{
                width: '22px',
                height: '2px',
                backgroundColor: darkMode ? '#fff' : '#333',
                transition: 'all 0.3s ease',
                transformOrigin: 'center',
                transform: !isCollapsed ? 'rotate(-45deg) translateY(-6px)' : 'none'
              }}
            ></div>
          </div>
        </button>
        
        {/* Collapsible Content */}
        <div 
          className={`collapse navbar-collapse ${!isCollapsed ? 'show' : ''}`} 
          id="navbarNav"
          style={{ 
            transition: 'all 0.35s ease',
          }}
        >
          <div className="navbar-nav ms-auto mt-3 mt-lg-0">
            {/* Language Selector */}
            <div className="nav-item mb-3 mb-lg-0 me-lg-4">
              <div className="d-flex flex-column flex-lg-row align-items-center">
                <label className="form-label mb-1 mb-lg-0 me-lg-2 text-nowrap fw-semibold" style={{ fontSize: '0.9rem' }}>
                  <i className="fas fa-globe me-2 text-primary"></i>
                  {t.language}
                </label>
                <select 
                  className={`form-select form-select-sm ${darkMode ? 'bg-dark text-light border-secondary' : 'border-light-subtle'} shadow-sm`}
                  value={language}
                  onChange={(e) => setLanguage(e.target.value)}
                  style={{ 
                    minWidth: '90px',
                    borderRadius: '8px',
                    padding: '6px 12px'
                  }}
                >
                  <option value="sk">🇸🇰 SK</option>
                  <option value="en">🇬🇧 EN</option>
                </select>
              </div>
            </div>
            
            {/* Dark Mode Toggle */}
            <div className="nav-item align-content-center">
              <div className="d-flex flex-row justify-content-around align-items-center">
                <label className="form-label mb-1 mb-lg-0 me-lg-2 text-nowrap fw-semibold" style={{ fontSize: '0.9rem' }}>
                  <i className={`fas ${darkMode ? 'fa-moon text-warning' : 'fa-sun text-warning'} me-2`}></i>
                  {t.language === 'sk' ? 'Téma' : 'Theme'}
                </label>
                <div className="form-check form-switch mb-0">
                  <input 
                    className="form-check-input" 
                    type="checkbox" 
                    id="darkModeSwitch"
                    checked={darkMode}
                    onChange={(e) => setDarkMode(e.target.checked)}
                    style={{ 
                      transform: 'scale(1.2)',
                      cursor: 'pointer'
                    }}
                  />
                  <label className="form-check-label ms-2 text-nowrap" htmlFor="darkModeSwitch" style={{ cursor: 'pointer', fontSize: '0.9rem' }}>
                    {darkMode ? t.darkMode : t.lightMode}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
